import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { fetchTicketDetail } from '../../api/salesMonitoring';
import './TicketDetailsView.css';

const TicketDetailsView = ({ ticket, bankDesc, date, onBack }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetchTicketDetail(ticket)
      .then((d) => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setError('Impossible de charger le ticket — verifie que le serveur backend tourne.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [ticket]);

  const details = data ? data.lines : [];
  const totalPoints = details.reduce((s, r) => s + r.points, 0);
  const totalAmount = details.reduce((s, r) => s + r.amount, 0);

  return (
    <Layout>
      <div className="tdv-wrapper">
        <div className="tdv-card">
          <div className="tdv-card-header">
            <span className="tdv-card-title">Ticket's Details</span>
          </div>

          <div className="tdv-info">
            <div className="tdv-info-row">
              <span className="tdv-info-label">Lottery</span>
              <span className="tdv-info-val">{data ? data.tirage_name : ''}</span>
            </div>
            <div className="tdv-info-row">
              <span className="tdv-info-label">Bank</span>
              <span className="tdv-info-val">{bankDesc}</span>
            </div>
            <div className="tdv-info-row">
              <span className="tdv-info-label">Ticket</span>
              <span className="tdv-info-val">{ticket}</span>
            </div>
            <div className="tdv-info-row">
              <span className="tdv-info-label">Date</span>
              <span className="tdv-info-val">{date}</span>
            </div>
          </div>

          <div className="tdv-table-bar"></div>

          {error && <p className="tdv-error">{error}</p>}
          {loading && <p className="tdv-loading">Chargement...</p>}

          {!loading && !error && (
            <table className="tdv-table">
              <thead>
                <tr>
                  <th>Move Type</th>
                  <th>Points</th>
                  <th>Number</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {details.map((r, i) => (
                  <tr key={i} className={r.bold ? 'tdv-row-bold' : 'tdv-row-light'}>
                    <td>{r.moveType}</td>
                    <td>{r.points}</td>
                    <td>{r.number}</td>
                    <td>{r.amount.toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="tdv-total-row">
                  <td><strong>Total:</strong></td>
                  <td><strong>{totalPoints}</strong></td>
                  <td></td>
                  <td><strong>{totalAmount.toFixed(2)}</strong></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>

        <div className="tdv-actions">
          <button className="tdv-back-btn" onClick={onBack}>↩</button>
          <button className="tdv-menu-btn">☰<br /><span>Menu</span></button>
        </div>
      </div>
    </Layout>
  );
};

export default TicketDetailsView;
